import { ActionTypesFactory, DEFAULT_ACTION_TYPES } from '../factories/actionTypes.factory';

const pitchesActionTypes = ActionTypesFactory('PITCHES', DEFAULT_ACTION_TYPES, { DELETE_CAROUSEL_PIC: 'PITCHES/DELETE_CAROUSEL_PIC' });
export default pitchesActionTypes;
